import { isMobile } from '@pascal/pascal-core';
import { Spine } from 'pixi-spine';

import {
  Text,
  Point,
  Assets,
  Sprite,
  Texture,
  Graphics,
  Container,
  BlurFilter,
  Application,
} from 'pixi.js';
import { gameLayers } from '../../core/constants/gameLayers';
import { PixiBase } from '../../core/pixi/PixiBase';
import { PixiGameDrawer } from '../../core/pixi/pixiGameDrawer';
import { mobileGameConfigs, webGameConfigs } from '../../core/pixi/config';

import { gameResources } from '../../core/pixi/resources';
import { BackgroundDrawer } from './backgroundDrawer';
import { CharacterDrawer } from './characterDrawer';
import { FishPopupDrawer } from './fishPopupDrawer';
import { TransitionDrawer } from './transitionDrawer';

export class GameMainDrawer extends PixiGameDrawer {
  constructor(props) {
    super(props);
    this.layers = {
      [gameLayers.background]: new BackgroundDrawer(),
      [gameLayers.character]: new CharacterDrawer(),
      [gameLayers.fishPopup]: new FishPopupDrawer(),
      [gameLayers.transition]: new TransitionDrawer(),
      *[Symbol.iterator]() {
        yield this[gameLayers.background];
        yield this[gameLayers.character];
        yield this[gameLayers.fishPopup];
        yield this[gameLayers.transition];
      },
    };
  }

  get background() {
    return this.layers[gameLayers.background];
  }

  get character() {
    return this.layers[gameLayers.character];
  }

  get fishPopup() {
    return this.layers[gameLayers.fishPopup];
  }

  get transition() {
    return this.layers[gameLayers.transition];
  }

  // handleWebOrMobileGameSprites() {
  //   if (isMobile()) {
  //     return [
  //       {
  //       {
  //         ...pixiResourceHelper.get(Object.keys(mobileGameImageSprites)[0]).textures,
  //         ...pixiResourceHelper.get(Object.keys(mobileGameImageSprites)[1]).textures,
  //         ...pixiResourceHelper.get(Object.keys(mobileGameImageSprites)[2]).textures,
  //       },
  //     ];
  //   }
  //   return [
  //     {
  //       ...pixiResourceHelper.get(Object.keys(webGameImageSprites)[0]).textures,
  //       ...pixiResourceHelper.get(Object.keys(webGameImageSprites)[1]).textures,
  //       ...pixiResourceHelper.get(Object.keys(webGameImageSprites)[2]).textures,
  //     },
  //   ];
  // }

  playFishAnimation(skinName) {
    return this.fishPopup.playFishAnimation(skinName);
  }

  createOddText(a) {
    this.fishPopup.createOddText(a);
  }

  resetSkeletonFromFishSpine() {
    this.fishPopup.resetSkeletonFromFishSpine();
  }

  updateOddText(odd) {
    this.fishPopup.updateOddText(odd);
  }

  stopFishAnimation() {
    this.fishPopup.stopFishAnimation();
  }

  playCharacterStaticAnimation() {
    this.character.playCharacterStaticAnimation();
  }

  playSharkAnimation() {
    if (this.character) {
      this.character.playSharkAnimation();
    }
  }

  playCharacterFishingAnimation() {
    if (this.character) {
      this.character.playCharacterFishingAnimation();
    }
  }

  playBackgroundShakeAnimation() {
    this.background.playBackgroundShakeAnimation();
  }

  playMarlinAnimation() {
    this.transition.playMarlinFishAnimation();
  }

  playBackgroundStaticAnimation() {
    this.background.playBackgroundStaticAnimation();
  }

  playTransitionAnimation() {
    this.transition.playTransitionAnimation();
  }

  resetAllAnimations() {
    this.fishPopup.resetAnimations();
    this.transition.resetAnimations();
  }

  execute(root) {
    return new Promise((resolve) => {
      super
        .loadResource({
          resource: gameResources,
          loader: PixiBase.createLoader(),
        })
        .then(() => {
          root.appendChild(this.pixiApplication.view);
          super.setupContainers([
            this.background.backgroundContainer,
            this.character.characterContainer,
            this.fishPopup.fishPopupContainer,
            this.transition.transitionContainer,
          ]);
          // const gameAllSprites = this.handleWebOrMobileGameSprites();
          [...this.layers].forEach((layer) => {
            layer.execute(isMobile() ? mobileGameConfigs : webGameConfigs, []); // 2-nd argument for execute gameAllSprites
          });
          resolve(true);
        });
    });
  }
}

export const gameMainDrawer = new GameMainDrawer({
  Spine,
  PIXI: { Application, Container, Sprite, Text, Texture, BlurFilter, Assets, Graphics, Point },
  config: isMobile() ? mobileGameConfigs.applicationConfigs : webGameConfigs.applicationConfigs,
});
